import styled from 'styled-components'

import { DashboardCSSVariables } from './Dashboard.styled'

export const LegendDashboardCSSVariables = styled(DashboardCSSVariables)`
    --legend-dashboard-header-background-color: #1c1f2a;
    --legend-dashboard-primary-color: #e37717;
    --legend-dashboard-secondary-color: #2366b1;
    --legend-dashboard-tertiary-color: #edac46;
    --dashboard-legend-border: solid 1px
        ${(props) => props.theme.colors.monochrome.concrete};
`

export const QuickActions = styled.div`
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    animation: fadeIn 0.3s ease-in-out;
    h3 {
        margin-top: 0;
        font-weight: bold;
        font-size: 20px;
        margin-right: 22px;
        padding-top: 15px;
    }
    button {
        border: none;
        border-radius: 2px;
        font-size: 15px;
        color: var(--dashboard-white-color);
        background-color: var(--dashboard-main-color);
        padding: 8px 25px;
        margin: 15px 0 15px 15px;
        height: 40px;
        animation: fadeIn 0.6s ease-in-out;
    }
`
